import { PatientInterface } from "@/api/interfaces/Patient";
import { defineStore } from "pinia";

export const useRegisterTestStore = defineStore("registerTestStore", {
  state: () => {
    return {
      canJumpNext: false,
      resultTest: "",
      resultTestCode: "",
      exposureTime: "",
      exposureTimeCode: "",
      testImage: "",
      testSymptoms: "",
      registerTestId: "",
      patient: { accept_terms: false } as PatientInterface,
    };
  },
});
